import { Client } from "@core/Client";
import * as Icons_SVG from "@core/GUI/Utils/IconsSVG";
import { VideoFeedStatic } from "./VideoFeedStatic";

/**
 * NanoCosmos video player implementation without using iframes
 */
declare var NanoPlayer: any
export class VideoFeedBintu extends VideoFeedStatic {

    private playerReady = false;
    private player: any;
    private silhouette = `<div id="silhouette_display_div" style="display: none; border-bottom: ${this.borderSize}px solid black; width: ${this.videoWidth}px; height: ${this.videoHeight}px; ">
								<div style="position: absolute; top: -99px; left: -11px">
									<div id="silhouette_play_button" style="transform: scale(0.9)">	
										${Icons_SVG.Silhouette_PLAY}
									</div>
								</div>
							</div>
	`
    private playerIFrameHTML = ` <div id="iframe_video_stream"
                                style="border: ${this.borderSize}px solid ${this.borderColor}; border-radius: 5px;
                                -webkit-user-select: none; -khtml-user-select: none; -moz-user-select: -moz-none;
                                -o-user-select: none; user-select: none; pointer-events: none;
                                width: ${this.videoWidth}px; height: ${this.videoHeight}px;
                                ">
                                <div id="playerDiv"></div>
                             </div>
    `
    private darkenVideoElement = `<div id="darken_video_element" style="visibility: hidden; background-color: #000000ab;position: absolute;width: 100%;height: 100%;top: 0;z-index: 2;"></div>`

    constructor(private _videoContainer: string, scene: Phaser.Scene) {
        super(_videoContainer, scene)

        // Removing void-warning-canvas-player-fix to position the void warning properly
        this.HTML = `
        <div draggable="false" class="unselectable" id="video_refresh_button" style="position: absolute; z-index: 9998; bottom: 15px; right: 15px; color: white; visibility: hidden;">
            <img draggable="false" unselectable="on" onselectstart="return false;" onmousedown="return false;" class="unselectable" style="z-index: 99999; filter: grayscale(1) invert(1) brightness(0.7); opacity: ${this.iconOpacity}; transform: translate3d(0px, 0px, 0px);" width="50px" id="refresh_video_button" src='data:image/svg+xml;utf8,${Icons_SVG.FullscreenSVG}' />
        </div>
        <div draggable="false" class="unselectable" id="video_stop_button" style="position: absolute; z-index: 9998; bottom: 15px; right: 15px; color: white;">
            <img draggable="false" unselectable="on" onselectstart="return false;" onmousedown="return false;" class="unselectable" style="z-index: 99999; filter: grayscale(1) invert(1) brightness(0.7); opacity: ${this.iconOpacity}; transform: translate3d(0px, 0px, 0px);" width="50px" id="stop_video_button" src='${Icons_SVG.PauseButton}' />
        </div>
        ${this.playerIFrameHTML}
        ${this.voidWarningDIV.replace('void-warning-canvas-player-fix', '')}
        ${this.darkenVideoElement}
        ${this.silhouette}
        `

        this.videoContainer.innerHTML = this.HTML

        // Deferred load of player script to not load it always 
        this.scene.load.script("stream", "nanoplayer.js");
        this.scene.load.once(Phaser.Loader.Events.COMPLETE, () => {
            this.initBintuPlayer()
        })
        this.scene.load.start();
    }

    handleDown(e): void {
        super.handleDown(e);
        if (this.player) this.player.unmute();
    }

    StopVideo(): void {
        if (this.player) this.player.pause();
        // this.videoContainer.style.display = "none";
        document.getElementById("iframe_video_stream").style.display = "none"
        document.getElementById("video_refresh_button").style.display = "none"
        document.getElementById("video_stop_button").style.display = "none"

        document.getElementById("silhouette_display_div").style.display = "block"
        this.silhouetteVisible = true
    }

    PlayVideo(): void {
        this.silhouetteVisible = false
        this.Show()
    }

    Show(): void {
        // super.Show()

        this.videoContainer.style.display = "block"

        if (this.silhouetteVisible) {
            // this.videoContainer.innerHTML = this.silhouetteHTML
            document.getElementById("silhouette_display_div").style.display = "block"
        } else {
            let muted = this.scene.registry.get("is_game_muted")
            // this.videoContainer.innerHTML = this.HTML.replace('name=""', "name='" + JSON.stringify({...this.logic.Stream, muted: muted}) + "'");	
            document.getElementById("silhouette_display_div").style.display = "none"

            document.getElementById("iframe_video_stream").style.display = "block"
            document.getElementById("video_refresh_button").style.display = "block"
            document.getElementById("video_stop_button").style.display = "block"
        }

        // this.videoContainer.firstElementChild.setAttribute("name", JSON.stringify(this.logic.Stream))
        // this.videoContainer.setAttribute("name", JSON.stringify(this.logic.Stream))
        this.visible = true
        this.softHidden = false

        if (this.player && this.playerReady)
            this.player.play();
        else if (!this.player && this.playerReady) {
            try {
                this.initBintuPlayer();
            }
            catch (e) { }
        }
    }

    Hide(forced: boolean): void {
        if (this.player) this.player.pause();

        this.videoContainer.style.display = "none";

        this.visible = false;
        this.softHidden = false;
    }

    // Must exist otherwise an exception will be thrown causing game breaking issues for iOS devices
    TryUnlockingAudioAfterGesture(): void {
        if (this.player && this.player.unmute) this.player.unmute()
    }

    private initBintuPlayer(): void {
        let entries = [];

        Client.logic.setup.videoPlayerSettings.sources.forEach(videoSource => {
            let entry = {
                index: videoSource.index,
                hls: "",
                label: videoSource.label,
                tag: "this is a " + videoSource.label + " quality stream",
                h5live: {
                    server: {
                        websocket: "wss://bintu-h5live.nanocosmos.de:443/h5live/stream/stream.mp4",
                        hls: "https://bintu-h5live.nanocosmos.de:443/h5live/http/playlist.m3u8",
                        progressive: "https://bintu-h5live.nanocosmos.de:443/h5live/http/stream.mp4"
                    },
                    rtmp: {
                        url: videoSource.url/*"rtmp://bintu-play.nanocosmos.de:1935/play"*/,
                        streamname: videoSource.streamName/*"VvqR9-WBTo2"*/
                    },
                    token: videoSource.token,
                    security: {}
                },
                bintu: {}
            }

            entries.push(entry)
        });

        let config = {
            source: {
                entries: entries,
                options: {
                    adaption: {
                        rule: "deviationOfMean2"
                    },
                    switch: {
                        method: 'server',
                        pauseOnError: false,
                        forcePlay: true
                    }
                },
                startIndex: (entries.length - 1)
            },
            playback: {
                autoplay: true,
                automute: false,
                muted: false,
                //flashplayer: "//demo.nanocosmos.de/nanoplayer/nano.player.swf"
            },
            style: {
                width: "100%",
                height: "100%",
                scaling: "fill"
            },
            events: {
                onReady: () => { }
            }
        }

        let divForPlayer = 'bintucloud'

        let elementforBINTU = document.createElement('div')
        elementforBINTU.setAttribute('id', divForPlayer)
        document.body.appendChild(elementforBINTU)

        let onReady = () => {
            this.playerReady = true
            console.log("Player is ready!")
        }

        config.events.onReady = onReady

        this.player = new NanoPlayer(divForPlayer);
        this.player.setup(config).then(function (config) {
            document.getElementById('playerDiv').style.position = "static";
            let d = document.getElementById('bintucloud')
            if (d) {
                d.style.width = "100%"
                d.style.height = "100%"
                d.style.borderRadius = "5px"
            }
            let i = document.getElementById('iframe_video_stream')
            if (i) {
                i.style.backgroundColor = "black"
                i.appendChild(d)
            }
        }, function (error) {

        });
    }

    protected setVideoVolume(value: number): void {
        if (this.player && this.player.setVolume) this.player.setVolume(value)
    }
}